(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const u = new URL(window.location.href);
  if (u.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const c = document.getElementById(u.hash.slice(1));
      if (c) c.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }
  document.addEventListener('click', (e) => {
    const d = document.querySelector('.bw-drawer');
    if (e.target.closest('[data-bw-filter-open]')) {
      d?.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-bw-filter-close]')) {
      d?.removeAttribute('data-open');
      document.body.style.overflow = '';
    }
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.bw-fg__head');
    if (!t) return;
    e.preventDefault();
    t.closest('.bw-fg').toggleAttribute('data-open');
  });
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-bw-sort-trigger]');
    const opt = e.target.closest('[data-bw-sort-option]');
    const dd = document.querySelector('.bw-sort');
    if (trigger) {
      e.stopPropagation();
      dd?.toggleAttribute('data-open');
      return;
    }
    if (opt) {
      const form = opt.closest('form');
      const value = opt.getAttribute('data-value');
      const hidden = form?.querySelector('input[name="sort_by"]');
      if (hidden) hidden.value = value;
      form?.submit();
      return;
    }
    if (dd && !e.target.closest('.bw-sort')) dd.removeAttribute('data-open');
  });
  document.addEventListener('change', (e) => {
    if (e.target.closest('.bw-filter-form input, .bw-filter-form select')) {
      e.target.closest('form')?.submit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  document.addEventListener('click', (e) => {
    const d = document.querySelector('.bw-drawer');
    if (e.target.closest('[data-bw-filter-open]')) {
      d?.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-bw-filter-close]')) {
      d?.removeAttribute('data-open');
      document.body.style.overflow = '';
    }
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.bw-fg__head');
    if (!t) return;
    e.preventDefault();
    t.closest('.bw-fg').toggleAttribute('data-open');
  });
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-bw-sort-trigger]');
    const opt = e.target.closest('[data-bw-sort-option]');
    const dd = document.querySelector('.bw-sort');
    if (trigger) {
      e.stopPropagation();
      dd?.toggleAttribute('data-open');
      return;
    }
    if (opt) {
      const form = opt.closest('form');
      const value = opt.getAttribute('data-value');
      const hidden = form?.querySelector('input[name="sort_by"]');
      if (hidden) hidden.value = value;
      form?.submit();
      return;
    }
    if (dd && !e.target.closest('.bw-sort')) dd.removeAttribute('data-open');
  });
  document.addEventListener('change', (e) => {
    if (e.target.closest('.bw-filter-form input, .bw-filter-form select')) {
      e.target.closest('form')?.submit();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
